export interface ExistingFile {
  id: string;
  name: string;
  url: string;
  size: number;
  type: string;
}

export interface UploadFileItem {
  id: string;
  file?: File;
  name: string;
  size: number;
  type: string;
  url?: string;
  progress: number;
  status: "pending" | "uploading" | "success" | "error" | "existing";
  error?: string;
}

let fileIdCounter = 0;

function generateId(): string {
  return typeof window !== "undefined" &&
    window.crypto &&
    typeof window.crypto.randomUUID === "function"
    ? window.crypto.randomUUID()
    : `${Date.now()}-${++fileIdCounter}-${Math.random().toString(36).substring(2, 15)}`;
}

export function createUploadFileItem(file: File): UploadFileItem {
  return {
    id: generateId(),
    file,
    name: file.name,
    size: file.size,
    type: file.type,
    progress: 0,
    status: "pending",
  };
}

export function createExistingFileItem(existing: ExistingFile): UploadFileItem {
  return {
    id: existing.id || generateId(),
    name: existing.name,
    size: existing.size,
    type: existing.type,
    url: existing.url,
    progress: 100,
    status: "existing",
  };
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 B";

  const units = ["B", "KB", "MB", "GB", "TB"];
  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${units[i]}`;
}
